module.exports = __webpack_public_path__ + "static/img/s37.32ff8fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s37.jpg
// module id = cztc
// module chunks = 1